import React from 'react';
import { branch } from 'baobab-react/higher-order';
import Helmet from 'react-helmet';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import Header from '../common/Header';
import { Link } from 'react-router';
import Tooltip from '../common/Tooltip';
import Option from './common/SafeSelectorOption';
import tree from '../../state';
import * as productService from '../../services/productService';

class Protection extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			facet: 'protectionFrom',
			selectedProtection: '',
			btnDisabled: true
		};
	}

	componentDidMount() {
		const query = {
			size: sessionStorage.getItem('selectedSize'),
			lockType: sessionStorage.getItem('selectedLockType')
		};
		const data = Object.assign({}, query, '');
		productService.productSearch(data).then(result => {
			tree.set('productSearchResults', result);
		});
		this.setState({
			selectedProtection: sessionStorage.getItem('selectedProtection'),
			btnDisabled: sessionStorage.getItem('selectedProtection') === null
		});
	}

	handleChange(e) {
		this.setState({
			selectedProtection: e.target.value,
			btnDisabled: false
		});
	}

	handleSubmit(e) {
		const { selectedProtection, btnDisabled } = this.state;
		if (btnDisabled) {
			e.preventDefault();
		} else {
			sessionStorage.setItem('selectedProtection', selectedProtection);
			global.dataLayer.push({
				event: 'Product Selector',
				eventCategory: 'Product Selector',
				eventAction: 'Continue - Step 4',
				eventLabel: global.location.pathname
			});
		}
	}

	handleSkip() {
		sessionStorage.removeItem('selectedProtection');
		global.dataLayer.push({
			event: 'Product Selector',
			eventCategory: 'Product Selector',
			eventAction: 'Skip - Step 4',
			eventLabel: global.location.pathname
		});
	}

	render() {
		const { facet, selectedProtection, btnDisabled } = this.state;
		const options = this.props.facets.filter(item => {
			return item.value === facet ? item : '';
		})[0].items;
		const lockProtection = options.map((item, index) => {
			let { name } = item;
			let description = '';
			let icon = '';
			let icon2x = '';
			if (name === 'Theft (non-Fire/Water)') {
				name = 'Theft';
				description = 'Help prevent theft with a variety of security features.';
				icon = 'security-icon.png';
				icon2x = 'security-icon@2x.png';
			} else if (name === 'Fire') {
				name = 'Fire & Theft';
				description = 'Fire resistance and theft protection combined.';
				icon = 'fire-theft-icon.png';
				icon2x = 'fire-theft-icon@2x.png';
			} else if (name === 'Water & Fire') {
				name = 'Water / Fire / Theft';
				description = 'Your best peace-of-mind: protection from flood, fire and theft.';
				icon = 'water-fire-theft-icon.png';
				icon2x = 'water-fire-theft-icon@2x.png';
			}

			return (
				<div className="col md-4 mb-4 protection-type" key={ index }>
					<figure>
						{
							icon !== '' ?
								<img
									src={ require(`../../resources/img/icons/${icon}`) }
									srcSet={ `${require(`../../resources/img/icons/${icon2x}`)} 2x` }
									alt=""
								/> : ''
						}
					</figure>
					<h2 className="h5">
						{ name }
					</h2>
					<p className="small mt-3 mx-auto">
						{ description }
					</p>
					<Option
						className="mt-3"						
						id={ `protectionType${index + 1}` }
						name="safeLockType"
						value={ item.value }
						checked={ selectedProtection === item.value }
						onChange={ e => this.handleChange(e) }
						label={ selectedProtection === item.value ? 'Selected' : 'Select' }
						trackEventAction="Protection From"
						trackEventLabel={ item.value }
					/>
				</div>
			);
		}).reverse();

		return (
			<div className="safe-selector">
				<Helmet>
					<title>Safe Selector | SentrySafe</title>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Safe Selector" />
				</Breadcrumb>

				<div className="steps-progress">
					<ol>
						<li className="on">
							<Link
								to="/safe-selector/capacity"
								onClick={ e => {
									global.dataLayer.push({
										event: 'Product Selector',
										eventCategory: 'Product Selector',
										eventAction: 'Link',
										eventLabel: e.target.textContent
									});
								} }
							>
								Capacity
							</Link>
						</li>
						<li className="on">
							<Link
								to="/safe-selector/lock-type"
								onClick={ e => {
									global.dataLayer.push({
										event: 'Product Selector',
										eventCategory: 'Product Selector',
										eventAction: 'Link',
										eventLabel: e.target.textContent
									});
								} }
							>
								Lock Type
							</Link>
						</li>
						<li className="on active">
							<span>Protection</span>
						</li>
						<li>
							<span>Results</span>
						</li>
					</ol>
				</div>

				<Header title="What do you need protection from?" />

				<span className="arrow-down" />

				<section className="section section-select-safe-protection py-5">
					<div className="section-content row text-center">
						<div className="col">
							<div className="select-safe-protections">
								<div className="row">
									{ lockProtection }
								</div>
							</div>

							<ul className="list-unstyled m-0 safe-selector-actions">
								<li>
									{
										btnDisabled ? 
											<Tooltip
												trigger={
													<Link
														className="btn btn-primary disabled"
														to="#"
														onClick={ e => this.handleSubmit(e) }
													>
														Continue
													</Link>
												}
												content="For the best results, please select an option."
											/>
											:
											<Link
												className="btn btn-primary"
												to="/safe-selector/results"
												onClick={ e => this.handleSubmit(e) }
											>
												Continue
											</Link>
									}
								</li>
								<li>
									<Link
										to="/safe-selector/lock-type"
										onClick={ () => {
											global.dataLayer.push({
												event: 'Product Selector',
												eventCategory: 'Product Selector',
												eventAction: 'Previous - Step 4',
												eventLabel: global.location.pathname
											});
										} }
									>
										Previous
									</Link>
								</li>
								<li>
									<Link
										to="/safe-selector/results"
										onClick={ () => this.handleSkip() }
									>
										Skip
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default branch({
	facets: ['productSearchResults', 'facets']
}, Protection);


// WEBPACK FOOTER //
// ./src/pages/safeSelector/Protection.js